import React from "react";
import {useTranslation} from "react-i18next";
import ROUTES from "../../routes/routes";
// Material-UI imports
import {Container} from "@material-ui/core";
import {LibraryFormCreate} from "./LibraryFormCreate";
import {BreadcrumbItem, BreadcrumbsRow} from "../common/breadcrumbs";
import {PageHeader} from "../common/headers";

export const LibraryNew: React.FC = () => {
    const [t] = useTranslation("libraries");
    return (
        <Container>
            <BreadcrumbsRow>
                <BreadcrumbItem name={t("library.titles.libraries")} route={ROUTES.libraries.path} />
                <BreadcrumbItem name={t("library.titles.new_library")} />
            </BreadcrumbsRow>
            <PageHeader title={t("library.titles.new_library")} />
            <LibraryFormCreate />
        </Container>
    );
};

export default LibraryNew;
